import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import ClickOutside from 'vue-click-outside'

import { DatePicker } from '@src/elements/input/date-picker'
import { Button } from '@src/elements/button/button'

import './plan-checkup.sass'

@Component({
  directives: {
    ClickOutside
  }
})
export default class PlanCheckup extends Vue {

  @Prop({ required: true })
  closeCallback: () => void

  @Prop({ required: true })
  chooseCallback: (startDate?: string) => void

  startDate: string = ''

  constructor () {
    super()
  }

  planCheckup () {
    this.chooseCallback(this.startDate)
  }

  render (h: CreateElement) {
    return <div class='plan-checkup-wrapper' v-click-outside={this.closeCallback}>
      <DatePicker allowPastDate={false} type='date' value={this.startDate} change={(value: string) => {
        this.startDate = value.toString()
      }} label={`${this.$t('DATE')}:`} />

      {this.startDate !== '' ? <Button class='save-btn' label={this.$t('PAGE.MEMBERS.CHECKUPS.PLAN_CHECKUP')} click={this.planCheckup} /> : null}
    </div>
  }
}
